import "./App.css";
import "bootstrap/dist/css/bootstrap.min.css";
import NavbarSection from "./components/navbar/Navbar";
import HomeSection from "./components/home/HomeSection";
import AboutSection from "./components/about/AboutSection";
import ServicesSection from "./components/services-section/ServicesSection";
import Contact from "./components/contact/Contact";
import Footer from "./components/footer/Footer";
import Blog from "./components/blog/Blog";
import Waves from "./components/shared/waves";
import ScrollToTop from "react-scroll-to-top";

function App() {
  return (
    <div className="App">
      <NavbarSection />
      <section id="home">
        <HomeSection />
      </section>
      {/* <Waves /> */}
      <section id="about">
        <AboutSection />
      </section>
      <section id="services">
        <ServicesSection />
      </section>
      <section id="blog">
        <Blog />
      </section>
      <section id="contact">
        <Contact />
      </section>
      <ScrollToTop smooth />
      <section id="footer">
        <Footer />
      </section>
    </div>
  );
}

export default App;
